@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.spinner-container {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 2rem;
}

.spinner {
  height: 2rem;
  width: 2rem;
}

.spinner::after {
  border: 0.25rem solid hsl(0deg 0% 0% / 10%);
  border-radius: 50%;
  content: " ";
  display: block;
  height: 100%;
  transform-origin: 50% 50%;
  width: 100%;
}

@media (prefers-reduced-motion: no-preference) {
  .spinner::after {
    animation: spin 1s cubic-bezier(0.455, 0.03, 0.515, 0.955) infinite;
    border-left-color: var(--color-uva-black);
  }
}
